import { z } from 'zod';

import { SavedItemPayloadSchema, SavedItemSchema } from '../validators/SavedItem.schema';

export type SavedItem = z.infer<typeof SavedItemSchema>;

export type SavedItemPayload = z.infer<typeof SavedItemPayloadSchema>;

export enum SavedItemType {
    COMPONENT = 'components',
    PROFILE = 'manufacturers',
    PROJECT = 'projects',
    COLLATERAL = 'collateral',
}
